var map = {
	"./android.png": 9403,
	"./aws.png": 6943,
	"./css.png": 7364,
	"./django.png": 6937,
	"./docker.png": 1792,
	"./figma.png": 1093,
	"./html.png": 4050,
	"./java.png": 8263,
	"./javascript.png": 2251,
	"./kubernetes.png": 3193,
	"./mongo.png": 2379,
	"./mysql.png": 6471,
	"./nodejs.png": 9701,
	"./php.png": 2147,
	"./postgresql.png": 5609,
	"./python.png": 2805,
	"./react.png": 6968,
	"./spring.png": 6550,
	"./typescript.png": 5978,
	"./webflow.png": 1609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4490;